<template>
  <div class="confirmation-field" v-if="value">
    <div class="labelSide">
      <legend>{{ label }}</legend>
    </div>
    <div class="valueSide">{{ value | humanizeFromOptions(options) }}</div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmationField',

  props: {
    label: {
      required: true,
      type: String,
    },
    value: {
      required: true,
    },
    options: {
      required: false,
    },
  },

  filters: {
    humanizeFromOptions(value, options) {
      if (!options) {
        return value;
      }

      return options
        .find((option) => option.value === value || parseInt(option.value, 10) === parseInt(value, 10))
        .label;
    },
  },
};
</script>

<style lang="scss" scoped>
  .confirmation-field {
    @apply flex;
    @apply py-3;
    @apply text-sm;

    .labelSide {
      @apply px-2;

      > legend {
        @apply text-gray-800;
        @apply font-bold;
      }

      @screen md {
        @apply w-1/4;
      }
    }

    .valueSide {
      @apply px-2;

      @screen md {
        @apply w-3/4;
      }
    }

    &:nth-of-type(even) {
      @apply bg-gray-100;
      @apply bg-opacity-50;
    }
  }
</style>
